module.exports = __webpack_public_path__ + "img/map2.f3748d01.png";